import Select from "react-select"
import React, { useEffect, useState } from "react"
import { getCountryOptions } from "common/SelectOptions/countryOptions"

const LandscapingTasksFilters = ({
  filteredLocations,
  filteredComplete,
  applyFilters
}) => {
  const [locationOptions, setLocationOptions] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState(filteredLocations);
  const [complete, setComplete] = useState(filteredComplete);

  useEffect(() => {
    const fetchOptions = async () => {
      setLocationOptions(await getCountryOptions());
    };
    fetchOptions();
  }, []);

  return (
    <div>
      {/* Filter by Location */}
      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-map-marker-outline me-1" />
          <h6 className="mb-0">Locations:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isMulti
            options={locationOptions}
            defaultValue={selectedLocations}
            className="basic-single"
            classNamePrefix="select"
            placeholder="Select locations"
            onChange={options => setSelectedLocations(options)}
          />
        </div>
      </div>

      <div className="d-flex my-2">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-chart-bar me-1" />
          <h6 className="mb-0">Complete:</h6>
        </div>
        <div className="ms-2" style={{ width: "100%" }}>
          <Select
            isClearable
            options={[{label: "True", value: true}, {label: "False", value: false}]}
            defaultValue={complete}
            className="basic-single"
            classNamePrefix="select"
            // placeholder="Select categories"
            onChange={options => setComplete(options)}
          />
        </div>
      </div>
    
      {/* Apply Filters Button */}
      <div className="d-flex" style={{ justifyContent: "center" }}>
        <button
          className="btn btn-success common-button"
          style={{ width: "90%" }}
          onClick={()=>
            applyFilters(
              selectedLocations, 
              complete
            )}
        >
          Apply
        </button>
      </div>
    </div>
  )
}

export default LandscapingTasksFilters
